import { clsx, Select } from "@alpacahq/ui/old";

import { getExpirationLabel } from "~/v2/components/orderTicket/option/utils";
import { ToggleButtonGroup } from "~/v2/components/ToggleButtonGroup";
import type { ViewState } from ".";

const TAB_OPTIONS: ViewState["tab"][] = ["Stocks", "Options"];
const OPTIONS_TYPES: ViewState["optionType"][] = [
  "Calls & Puts",
  "Calls",
  "Puts",
];
export interface ViewControlsProps {
  isCrypto: boolean;
  viewState: ViewState;
  onViewChange: (viewState: Partial<ViewState>) => void;
  selectedExpiration: string | undefined;
  onExpirationSelected: (expiration: string) => void;
  expirations: string[];
}

export const ViewControls = ({
  isCrypto,
  viewState,
  onViewChange,
  selectedExpiration,
  onExpirationSelected,
  expirations,
}: ViewControlsProps) => {
  return (
    <div className="relative z-40 flex flex-1 flex-wrap justify-start gap-2 lg:flex-nowrap">
      {!isCrypto && (
        <div className="transform transition-all duration-500 ease-in-out">
          <ToggleButtonGroup
            options={TAB_OPTIONS}
            selectedOption={viewState.tab}
            onOptionClick={(value) =>
              onViewChange({ tab: value as ViewState["tab"] })
            }
          />
        </div>
      )}
      <div
        className={clsx(
          "flex flex-wrap gap-2 opacity-0 transition-all ease-in-out lg:flex-nowrap",
          // to prevent flashing, we use opacity and pointer-events
          viewState.tab === "Options" && "opacity-100",
          viewState.tab !== "Options" && "pointer-events-none",
        )}
      >
        <ToggleButtonGroup
          options={OPTIONS_TYPES}
          selectedOption={viewState.optionType}
          onOptionClick={(value) =>
            onViewChange({ optionType: value as ViewState["optionType"] })
          }
        />
        <Select
          multiple={false}
          placeholder="Expires On"
          className="ml-auto h-10 border-none bg-zinc-100 px-3 text-sm"
          value={selectedExpiration ?? ""}
          onChange={(value) => onExpirationSelected(value)}
          // Not sure what this was used for...
          // callback={(open) => {
          //   if (isControlOpen !== open) {
          //     update({ isControlOpen: open });
          //   }
          // }}
          options={expirations.map((value) => ({
            key: value,
            value,
            label: getExpirationLabel(value, "MMM DD, YYYY", "bracket"),
          }))}
        />
      </div>
    </div>
  );
};
